// AI-generated. Reviewed by: —
import axiosClient from './axiosClient';
import type {
  UserInvitation,
  CreateInvitationRequest,
  AcceptInvitationResponse,
} from '../types/invitation';

export const listInvitations = (): Promise<UserInvitation[]> =>
  axiosClient.get<UserInvitation[]>('/admin/invitations').then((r) => r.data);

export const getInvitation = (id: string): Promise<UserInvitation> =>
  axiosClient.get<UserInvitation>(`/admin/invitations/${id}`).then((r) => r.data);

export const createInvitation = (
  data: CreateInvitationRequest,
): Promise<UserInvitation> =>
  axiosClient.post<UserInvitation>('/admin/invitations', data).then((r) => r.data);

export const acceptInvitation = (token: string): Promise<AcceptInvitationResponse> =>
  axiosClient
    .post<AcceptInvitationResponse>('/admin/invitations/accept', { token })
    .then((r) => r.data);
